/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./KnowledgeTrust.css";
import { FiPhoneCall } from "react-icons/fi";

export default function PartTimeTrust() {
  return (
    <>
      {/* ===================== SERVICES PLACEHOLDER ===================== */}
      <section className="densat-trust-v2-services">
        {/* future content */}
      </section>

      {/* ===================== CTA SECTION ===================== */}
      <section className="densat-trust-v2-cta">
        <h2 className="densat-trust-v2-title">
          Ready to Transform Your Facility?
        </h2>

        <p className="densat-trust-v2-desc">
          Get a free site assessment and discover how we can help maintain
          world-class environments.
        </p>

        <div className="hero-buttons">
          {/* WhatsApp CTA */}
          <a
            href="https://wa.me/919899811123?text=Hello%20I%20would%20like%20a%20free%20site%20assessment"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            Request a Free Site Assessment →
          </a>

          {/* Call CTA */}
          <a href="tel:+91-9899811123" className="btn-outline">
            <FiPhoneCall className="btn-icon" />
            Call Now for a Tailored Quote
          </a>
        </div>
      </section>
    </>
  );
}
